import React from "react";

const pageFont = '"Lucida Grande", Helvetica, Verdana, Arial, sans-serif';

// Reusable StageBar - same visual as CrmV2OpportunityFormView StageBar
// Props: stages: [{id, name}], currentStageId: string|number, onSelect: (stage)=>void
const StageBar = ({ stages = [], currentStageId, onSelect }) => {
  const activeId = String(currentStageId || "");
  if (!stages.length) return null;
  return (
    <div className="crm-stage-bar" style={{ display: "flex", alignItems: "stretch", height: 38, flex: "1 1 auto", minWidth: 0, overflow: "hidden", border: "1px solid #dee2e6", background: "#e9ecef" }}>
      {stages.map((stage, index) => {
        const active = String(stage.id) === activeId;
        const first = index === 0;
        const last = index === stages.length - 1;
        let clipPath = "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%, 10px 50%)";
        if (first) clipPath = "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
        if (last) clipPath = "polygon(0 0, 100% 0, 100% 100%, 0 100%, 10px 50%)";
        if (stages.length === 1) clipPath = "none";
        return (
          <button
            key={stage.id}
            type="button"
            title={stage.name}
            onClick={() => onSelect && onSelect(stage)}
            style={{
              flex: "1 1 0",
              minWidth: 62,
              border: 0,
              marginLeft: first ? 0 : -10,
              padding: first ? "0 8px" : "0 8px 0 18px",
              clipPath,
              background: active ? "#212529" : "#e9ecef",
              color: active ? "#fff" : "#495057",
              fontFamily: pageFont,
              fontSize: 9,
              fontWeight: active ? 700 : 500,
              lineHeight: 1,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: onSelect ? "pointer" : "default",
            }}
          >
            {stage.name}
          </button>
        );
      })}
    </div>
  );
};

export const SALE_ORDER_STAGES = [
  { id: "draft", name: "QUOTATION" },
  { id: "sent", name: "QUOTATION SENT" },
  { id: "sale", name: "SALES ORDER" },
];

export const INVOICE_STAGES = [
  { id: "draft", name: "DRAFT" },
  { id: "posted", name: "POSTED" },
];

export default StageBar;
